import { FM_UPLOAD, FM_URL } from 'app/constants';
import { requestDelete, requestPost } from 'app/utils/request';
const remove = (data) => requestDelete(FM_URL, { data });
const upload = (data, option) => requestPost(FM_UPLOAD, data, option);
export default {
    remove,
    upload
};
